var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPriceTagOrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5146 10.5224L10.5308 16.5063C10.3758 16.6615 10.1917 16.7846 9.98904 16.8686C9.78641 16.9526 9.56921 16.9958 9.34986 16.9958C9.13051 16.9958 8.91331 16.9526 8.71068 16.8686C8.50805 16.7846 8.32396 16.6615 8.16894 16.5063L1 9.34569V1H9.34568L16.5146 8.16894C16.8255 8.48168 17 8.90472 17 9.34569C17 9.78665 16.8255 10.2097 16.5146 10.5224V10.5224Z",
    stroke: "#FF865D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.17285 5.17285H5.1812",
    stroke: "#FF865D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPriceTagOrange);
export default __webpack_public_path__ + "static/media/price-tag-orange.ed62a3fe41a38dacd353e785d2d0aed4.svg";
export { ForwardRef as ReactComponent };